import { render, staticRenderFns } from "./AppSettingsMenu.vue?vue&type=template&id=09bdafb4"
import script from "./AppSettingsMenu.vue?vue&type=script&lang=js"
export * from "./AppSettingsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports